import type { BlockFieldStyle } from '@/blocks/domain/types';

/**
 * The one human name of an element type, per `BlockFieldStyle` (LLAMS-839). Every surface that names an
 * element without authored text (the Sections panel tree, the field list rows, the canvas selection
 * tab, the Add palette) reads it from here, so the wire value is never shown to the user:
 * "rich_text" is the palette's "Text" tile, not "Rich Text".
 *
 * `headingTier` disambiguates the Heading row's label only: tier 1 is the Cover page's one H1, tier 2
 * is the Header block's document heading, tier 3 (the default) is every other section heading.
 */
export function fieldStyleLabel(style: BlockFieldStyle, headingTier: 1 | 2 | 3 = 3): string {
  switch (style) {
    case 'title':
      return 'Title';
    case 'heading':
      return headingTier === 1 ? 'Cover page Heading' : 'Heading';
    case 'subheading':
      return 'Subheading';
    case 'image':
      return 'Image';
    case 'value':
      return 'Variable';
    case 'dataset':
      return 'Dataset';
    case 'logo':
      return 'Logo';
    case 'text':
      return 'Text';
    case 'rich_text':
      return 'Text';
    case 'caption':
      return 'Caption';
    case 'signature_line':
      // Legacy rows only — no longer addable; see `ADDABLE_FIELD_STYLES`.
      return 'Signature line';
    case 'label_value':
    default:
      return 'Label + value';
  }
}
